module.exports = __webpack_public_path__ + "img/check.65e50d46.svg";